(function () {
  var prefetchedUrls = {};

  function shouldPrefetch() {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return true;
    if (conn.saveData) return false;
    if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return false;
    return true;
  }

  function applyDeferredImage(img) {
    if (!img || img.hasAttribute('data-mm-loaded')) return;

    var src = img.getAttribute('data-mm-defer-src');
    var srcset = img.getAttribute('data-mm-defer-srcset');

    img.setAttribute('data-mm-loaded', '');

    if (srcset) {
      img.setAttribute('srcset', srcset);
    }

    if (src) {
      img.src = src;
    }
  }

  function loadDeferredImages(root) {
    if (!root) return;

    root.querySelectorAll('img[data-mm-defer-src]:not([data-mm-loaded])').forEach(applyDeferredImage);
  }

  function groupUnloadedImages() {
    var groups = {};

    document.querySelectorAll('img[data-mm-defer-src]:not([data-mm-loaded])').forEach(function (img) {
      var src = img.getAttribute('data-mm-defer-src');
      if (!src) return;

      if (!groups[src]) {
        groups[src] = {
          src: src,
          srcset: img.getAttribute('data-mm-defer-srcset'),
          sizes: img.getAttribute('sizes'),
          imgs: [],
        };
      }

      groups[src].imgs.push(img);
    });

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }

  function prefetchImageGroup(group) {
    return new Promise(function (resolve) {
      if (prefetchedUrls[group.src]) {
        group.imgs.forEach(applyDeferredImage);
        resolve();
        return;
      }

      var loader = new Image();
      loader.decoding = 'async';

      if (group.srcset) {
        loader.srcset = group.srcset;
        if (group.sizes) loader.sizes = group.sizes;
      }

      var finish = function () {
        prefetchedUrls[group.src] = true;
        group.imgs.forEach(applyDeferredImage);
        resolve();
      };

      loader.onload = finish;
      loader.onerror = finish;
      loader.src = group.src;
    });
  }

  function prefetchMegaMenuImages() {
    if (!shouldPrefetch()) return;

    var groups = groupUnloadedImages();
    if (!groups.length) return;

    groups.reduce(function (chain, group) {
      return chain.then(function () {
        return prefetchImageGroup(group);
      });
    }, Promise.resolve());
  }

  function scheduleBackgroundPrefetch() {
    var run = function () {
      prefetchMegaMenuImages();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      setTimeout(run, 1500);
    }
  }

  function loadDesktopPanelImages(details) {
    if (!details) return;

    var container = details.querySelector('[data-meganav-target-container]')
      || details.querySelector('[data-nav-desktop-submenu]')
      || details;

    loadDeferredImages(container);
  }

  function scanOpenDesktopPanels(root) {
    if (!root) return;

    root.querySelectorAll('[data-nav-desktop-details][open]').forEach(loadDesktopPanelImages);
  }

  function observeDesktopMegaMenus() {
    var header = document.querySelector('[data-desktop-header]') || document.querySelector('[data-nav-desktop]');
    if (!header || header.dataset.mmPromoObserved) return;

    header.dataset.mmPromoObserved = 'true';

    var observer = new MutationObserver(function () {
      scanOpenDesktopPanels(header);
    });

    observer.observe(header, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });

    document.addEventListener('mouseenter', function (event) {
      var parent = event.target.closest('.nav-desktop__tier-1-item--widemenu-parent');
      if (!parent || !header.contains(parent)) return;

      var details = parent.querySelector('[data-nav-desktop-details]');
      loadDesktopPanelImages(details);
    }, true);

    scanOpenDesktopPanels(header);
  }

  var mobilePromosLoaded = false;

  function loadMobilePromosOnce() {
    if (mobilePromosLoaded) return;
    mobilePromosLoaded = true;
    loadDeferredImages(document.getElementById('mobile_menu'));
    loadDeferredImages(document.querySelector('.mobile-meganav-source'));
  }

  function observeMobileMenu() {
    var bodyObserver = new MutationObserver(function () {
      if (document.body.classList.contains('mobile-menu-open')) {
        loadMobilePromosOnce();
      }
    });

    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function hookMeganavInject() {
    if (!window.meganavManager || window.meganavManager.__mmPromoHooked) return;

    var originalInjectAll = window.meganavManager.injectAll.bind(window.meganavManager);

    window.meganavManager.injectAll = function () {
      originalInjectAll();
      scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);

      if (document.readyState === 'complete') {
        prefetchMegaMenuImages();
      }
    };

    window.meganavManager.__mmPromoHooked = true;
  }

  function init() {
    observeDesktopMegaMenus();
    observeMobileMenu();
    hookMeganavInject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.readyState === 'complete') {
    scheduleBackgroundPrefetch();
  } else {
    window.addEventListener('load', scheduleBackgroundPrefetch);
  }

  document.addEventListener('shopify:section:load', function () {
    observeDesktopMegaMenus();
    hookMeganavInject();
    scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);

    if (document.readyState === 'complete') {
      scheduleBackgroundPrefetch();
    }
  });

  setTimeout(init, 0);
  setTimeout(function () {
    hookMeganavInject();
    scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);
  }, 500);
})();
